import { useEffect, useState } from "react";
import Pagination from "../../components/Table/pagination";
import useAuth from "../../hooks/useAuth";
import useFetch from "../../hooks/useFetch";

import { useNavigate, useLocation } from "react-router-dom";
import UseAxiosPrivate from "../../hooks/useAxiosPrivate";
import Popup from "reactjs-popup";
import CallFeedback from "../../components/Feedbacks/Feedback";
import axios from "axios";
// import axios from "../../utils/axios";
import { ReactComponent as Outgoing } from "../../assets/icons/outgoingcall.svg";

// PDF DOWNLOAD //
import jsPDF from "jspdf";
import "jspdf-autotable";

// EXCEL DOWNLOAD //
import * as XLSX from "xlsx"; // Import all exports from 'xlsx'

import { ReactComponent as Pdf } from "../../assets/icons/pdf-file-svgrepo-com.svg";
import { ReactComponent as Excel } from "../../assets/icons/excel-svgrepo-com.svg";
import { BarChart3 } from "lucide-react";
import Swal from "sweetalert2";

console.log("enter VsipOutgoingCampaignReport")

function VsipOutgoingCampaignReport(props) {
  const [resolvedWaveUrls, setResolvedWaveUrls] = useState({});
  const [showSearchTooltip, setShowSearchTooltip] = useState(false);
  const [camplist, setCampList] = useState([]);
  const axiosPrivate = UseAxiosPrivate();
  const fetchData = useFetch();
  const navigate = useNavigate();
  const location = useLocation();

  const BASE_URL = process.env.REACT_APP_API_URL;

  const { auth } = useAuth();
  const permissions = Array.isArray(auth?.permissions?.data) ? auth.permissions.data : [];
  const hasCustomerDescription = permissions.some((perm) => perm?.name === "CustomerDescription");

  const [fback, setfback] = useState(false);

  const [campaignRepotData, setCampaignReportData] = useState([]);

  const [campaign, setCampaign] = useState("");

  const [status, setStatus] = useState("");
  const [agents, setAgents] = useState([]);
  const [selectedAgent, setSelectedAgent] = useState("");
  const [agentSearch, setAgentSearch] = useState("");
  const [showAgentOptions, setShowAgentOptions] = useState(false);

  const [filterData, setFilerData] = useState("")

  /// Fro Date ///
  const [fromDate, setFromDate] = useState("");
  /// To Date ///
  const [toDate, setToDate] = useState("");

  const [callDirection, setCallDirection] = useState("");
  const [chosenTag, setChosenTag] = useState("");

  // -------------------------------- PAGINATION -------------------------------- //
  const Initial_pagination = {
    next: "",
    previous: "",
    count: "",
    total_pages: "",
    current_page: 1,
    page_size: 5,
  };

  const [pagination, setPagination] = useState(Initial_pagination);

  const PaginationControl = (type, number) => {
    if (type == "page") {
      if (number <= pagination.total_pages) {
        fetchCampaignReport(number);
      } else {
        fetchCampaignReport(1);
      }
    } else if (type == "last") {
      fetchCampaignReport(pagination.total_pages);
    } else if (type == "prev") {
      if (pagination.current_page > 1) {
        fetchCampaignReport(pagination.current_page - 1);
      }
    } else if (type == "next") {
      if (pagination.current_page < pagination.total_pages) {
        fetchCampaignReport(pagination.current_page + 1);
      }
    } else {
      fetchCampaignReport(1);
    }
  };

  // -------------------------------- END -------------------------------- //

  const initial_fb_data = {
    camp_data: {},
    customer_data: {},
    uid: "",
  };

  const [FBcampData, setFBcampData] = useState(initial_fb_data);

  useEffect(() => {
    if (fback === false) {
      setFBcampData(initial_fb_data);
      fetchCampaignReport(pagination.current_page);
    }
  }, [fback]);

  const initial_fbData = {
    id: "0",
    uid: props.call_id,
    agent_id: "",
    customer_id: "",
    answers: {},
    fbanswer: {},
    comment: "",
    folloup: "",
  };

  const [fbdata, setfbdata] = useState(initial_fbData);

  //  SEARCH //
  const [searchData, setSearchData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [userType, setUserType] = useState("");

  const fetchAgents = async () => {
    try {
      const response = await fetchData(
        "get",
        {},
        `${process.env.REACT_APP_API_URL}/contactcentre/agents-dropdown/`
      );
      setAgents(response);
    } catch (err) {
      console.error("Error fetching agents:", err);
    }
  };


  const fetchCampaignReport = async (pagenumber) => {
    let post_data;

    console.log(auth?.user_details)

    if (auth?.user_details?.type === "agent") {
      post_data = {
        userProfileId: auth?.user_details?.id,
        // userProfileId: 2,
        fromDate:fromDate || "",
        toDate:toDate || "",
        search:searchText || "",
        callDirection: callDirection || "",
        download: "",
        callStatus: status || "",
        tag_filter: chosenTag || "",
        user_filter: selectedAgent || "",
        version: "v2",
        userType: "sys_user",
        destinationType:"",
        comment:"",
        vsip_user_name: auth?.user_details.sip_details? auth?.user_details.sip_details?.sip_id: "",
        page: pagenumber,
        pagination_count:10,
        remove_empty_agent:"yes"

        // user_id: auth?.user_details?.user,
        // user_type: auth?.user_details?.type,
        // download: "yes",
        // campaign: campaign || "",
        // input_text: searchText,
        // status: status,
        // filter_data:filterData,
        // page: pagenumber,
        // from: fromDate || "",
        // to: toDate || "",
        // user_status: userType || "",
      };
    } else {
      post_data = {
        userProfileId: auth?.user_details?.id,
        // userProfileId: 2,
        fromDate:fromDate || "",
        toDate:toDate || "",
        search:searchText || "",
        callDirection: callDirection || "",
        download: "",
        callStatus: status || "",
        tag_filter: chosenTag || "",
        user_filter: selectedAgent || "",
        version: "v2",
        userType: "sys_admin",
        destinationType: "",
        comment:"",
        vsip_user_name: "",
        page: pagenumber,
        pagination_count:10,
        remove_empty_agent:"yes"


        // user_id: auth?.user_details?.user,
        // user_type: auth?.user_details?.type,
        // download: "yes",
        // campaign: campaign || "",
        // input_text: searchText,
        // status: status,
        // filter_data: filterData,
        // page: pagenumber,
        // from: fromDate || "",
        // to: toDate || "",
        // user_status: userType || "",
      };
    }
    let isMounted = true;
    const controller = new AbortController();

    console.log("--------------REfredgdsjfds-----------------");

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/VirtualsipReport/?page=${pagenumber || 1}`,
        post_data,
        {
          signal: controller.signal,
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      // const res_data = await fetchData(
      //   "post",
      //   post_data,
      //   `${process.env.REACT_APP_API_URL}/VirtualsipReport/?page=${pagenumber || 1}`
      // );
      
      setCampaignReportData(response.data?.results || []);
      setPagination((prevState) => ({
        ...prevState,
        next: response.data?.next || "",
        previous: response.data?.previous || "",
        count: response.data?.count || 0,
        total_pages: response.data?.total_pages || 0,
        current_page: response.data?.current_page || 1,
        page_size: response.data?.page_size || 10,
      }));
    } catch (err) {
      console.error(err);
      navigate("/login", { state: { from: location }, replace: true });
    }
  };

  const [reportTags, setReportTags] = useState([]);

  useEffect(() => {
    var admin_id;
    if(auth?.user_details?.type === "agent"){
      admin_id = auth?.user_details?.parent
    }else{
      admin_id = auth?.user_details?.id
    }

    const fetchReportTags = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/report_tag_main/${admin_id}/`,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        setReportTags(response.data?.report_tags || []);
      } catch (err) {
        console.error("Error fetching report tags:", err);
      }
    };

    if (auth?.user_details?.id) {
      fetchReportTags();
    }
  }, [auth?.user_details?.id]);

  useEffect(() => {
    fetchAgents();
  }, []);

  const FeatchFeebackDetails = async (agent_id, uid, customer_id) => {
    let isMounted = true;
    const controller = new AbortController();

    let post_fb_data = {
      calluid: uid,
      agent_id: agent_id,
    };

    try {
      const response = await axiosPrivate.get(
        process.env.REACT_APP_API_URL + "/contactcentre/get_fb_data/",
        {
          signal: controller.signal,
          params: post_fb_data,
        }
      );

      if (isMounted) {
        setFBcampData((prev) => {
          return {
            ...prev,
            camp_data: response.data.camp_data || {},
            customer_data: response.data.customer_data || {},
            uid: uid,
          };
        });

        let fb_data = response.data.fobj_data;

        if (fb_data.follow_up_date === "") {
          setfbdata({
            id: "0",
            uid: uid,
            agent_id: fb_data.feedback_agent,
            customer_id: "",
            answers: {},
            fbanswer: {},
            comment: "",
            folloup: "",
          });
        } else {
          setfbdata((prev) => {
            return {
              ...prev,
              id: fb_data.id,
              agent_id: fb_data.feedback_agent,
              customer_id: fb_data.campaign_customer,
              answers: fb_data.feedback_questions,
              fbanswer: fb_data.feedback_labels,
              comment: fb_data.comment,
              folloup: fb_data.follow_up_date,
              uid: fb_data.uid,
            };
          });
        }
      }
    } catch (err) {
      console.error(err);
      navigate("/login", { state: { from: location }, replace: true });
    }
    setfback(true);
  };


  const AddFeedback = (agent_id, camp_uid, customer_id, type = "GET") => {
    FeatchFeebackDetails(agent_id, camp_uid, type, customer_id);
  };

  const SearchCampaign = () => {
    fetchCampaignReport(1);
  };

  const SetFeedbackData = (agent_id, fb_id, type = "GET") => {
    FeatchFeebackDetails(agent_id, fb_id, type);
    setfback(true);
  };

  // Download Voice File //

  const EXCEL_COLUMNS = [
    { key: "DID", label: "DID", default: true },
    { key: "Date", label: "Date", default: true },
    { key: "Customer Name", label: "Customer Name", default: true },
    { key: "Customer Number", label: "Customer Number", default: true },
    { key: "Country Code", label: "Country Code", default: true },
    { key: "Agent Name", label: "Agent Name", default: true },
    { key: "Agent Number", label: "Agent Number", default: true },
    // { key: "Destination Name", label: "Destination Name", default: true },
    { key: "Call Duration", label: "Call Duration", default: true },
    { key: "Connected Duration", label: "Connected Duration", default: true },
    { key: "Rating", label: "Rating", default: true },
    { key: "Call Direction", label: "Call Direction", default: true },
    { key: "Comment", label: "Comment", default: true },
    { key: "Status", label: "Status", default: true },
    { key: "Voice File", label: "Voice File", default: true },
  ];

  const [selectedColumns, setSelectedColumns] = useState(
    () => new Set(EXCEL_COLUMNS.filter((c) => c.default).map((c) => c.key))
  );
  const [showColumnPicker, setShowColumnPicker] = useState(false);

  const toggleColumn = (key) => {
    setSelectedColumns((prev) => {
      const next = new Set(prev);
      next.has(key) ? next.delete(key) : next.add(key);
      return next;
    });
  };

  const toggleAllColumns = () => {
    if (selectedColumns.size === EXCEL_COLUMNS.length) {
      setSelectedColumns(new Set());
    } else {
      setSelectedColumns(new Set(EXCEL_COLUMNS.map((c) => c.key)));
    }
  };


  // const DownloadRecord = async (vffile, date, id) => {
  //   console.log("Downloading record:", vffile, date, id);

  //   let obj = {
  //     url: vffile,
  //     date: date,
  //   };

  //   let config = {
  //     headers: { "Content-Type": "application/json" },
  //   };

  //   let CALL_RECORD_URL = "/callrecordfile/";

  //   try {
  //     const response = await axios.post(
  //       BASE_URL + CALL_RECORD_URL,
  //       obj,
  //       config
  //     );

  //     if (response?.data?.status == 1) {
  //       // Conversion succeeded, refresh report data so the audio src is up to date
  //       fetchCampaignReport(pagination.current_page);

  //       campaignRepotData.map((item) => {
  //         if (item.callRecordVF === vffile) {
  //           const audioElement = document.getElementById(item.callRecordVF);
  //           if (audioElement) {
  //             audioElement.load();
  //           }
  //         }
  //       });
  //     }
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };


  const DownloadRecord = async (vffile, date, id) => {
  let obj = { url: vffile, date: date };
  let config = { headers: { "Content-Type": "application/json" } };
  let CALL_RECORD_URL = "/callrecordfile/";

  try {
    const response = await axios.post(BASE_URL + CALL_RECORD_URL, obj, config);

    if (response?.data?.status == 1) {
      const rawWaveUrl = response.data.wave_url;

      // Backend has returned both relative paths (older) and full absolute
      // URLs (current test-server). Normalize so either works.
      const waveUrl = rawWaveUrl
        ? rawWaveUrl.startsWith("http")
          ? rawWaveUrl
          : `${BASE_URL}/${rawWaveUrl}`
        : null;

      if (waveUrl) {
        setResolvedWaveUrls((prev) => ({ ...prev, [vffile]: waveUrl }));
      }

      fetchCampaignReport(pagination.current_page);

      const audioElement = document.getElementById(vffile);
      if (audioElement) {
        if (waveUrl) {
          audioElement.src = waveUrl;
        }
        audioElement.load();
      }
    }
  } catch (err) {
    console.log(err);
  }
};

  // -------   Download Data  -------- //

  const [downloadData, setDownloadData] = useState([]);

  const downloadSheet = async (type) => {
  try {
    const DownloadFunction = async (description) => {
      let post_data;

      if (auth?.user_details?.type === "agent") {
        post_data = {
          userProfileId: auth?.user_details?.id,
          fromDate: fromDate || "",
          toDate: toDate || "",
          search: searchText || "",
          callDirection: callDirection || "",
          download: "yes",
          callStatus: status || "",
          tag_filter: chosenTag || "",
          userType: "sys_user",
          destinationType: "",
          comment: "",
          vsip_user_name: "",
          user_filter: selectedAgent || "",
          version: "v2",
        };
      } else {
        post_data = {
          userProfileId: auth?.user_details?.id,
          fromDate: fromDate || "",
          toDate: toDate || "",
          search: searchText || "",
          callDirection: callDirection || "",
          download: "yes",
          callStatus: status || "",
          tag_filter: chosenTag || "",
          userType: "sys_admin",
          destinationType: "",
          comment: "",
          vsip_user_name: "",
        };
      }

      const controller = new AbortController();

      let response_data = [];

      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/VirtualsipReport/`,
          post_data,
          {
            signal: controller.signal,
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        // Pull the actual array out of the axios response
        response_data = response.data?.results || response.data || [];
      } catch (err) {
        console.error("Download fetch error:", err);
        response_data = [];
      }

      try {
        if (type == "PDF") {
          downloadpdfData(response_data, description);
        } else {
          downloadxcelData(response_data, description);
        }
      } catch (error) {
        console.error("Error:", error);
      }
    };

    if (hasCustomerDescription && type != "PDF") {
      if (campaign !== "") {
        Swal.fire({
          title: "Confirm",
          html: `
            <div class="text-center">
              <p>
                Do you want to include 
                <span class="font-bold text-red-500">"Description"</span> 
                in the Excel report?
              </p>

              <label class="flex items-center justify-center mt-3 gap-2">
                <input type="checkbox" id="includeDescription">
                Yes, include Description
              </label>
            </div>
          `,
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "OK",
          icon: "info",
          preConfirm: () => {
            const checkbox = Swal.getPopup().querySelector("#includeDescription").checked;
            return checkbox ? "yes" : "no";
          },
        }).then((result) => {
          if (result.isConfirmed) {
            DownloadFunction(result.value);
          }
        });
      } else {
        DownloadFunction("no");
      }
    } else {
      DownloadFunction("no");
    }
  } catch (error) {
    console.log(error);
  }
};

  const callStatusData = {
  "NOANSWER":"Unanswered",
  "FAILED":"Failed to progress",
  "ANSWERED":"Answered by destination",
  "BUSY":"Destination number is Busy",
  "CONGESTION":"Failed due to network Congestion",
  "CANCEL":"Canceled by the Caller",
  "CHANUNAVAIL":"Destination is Unavailable",
  "NUMBER_UNALLOCATED":"Unallocated Phone Number",
  "TEMPFAILURE":"Temporary Call Failure",
  "REJECTED":"Rejected by Destination",
  "UNREACHABLE":"Destination number is Unreachable",
  "NUMBER_INVALID":"Invalid Destination Phone Number"
  }

  const successStatuses = ["ANSWERED"];

  const warningStatuses = [
    "NOANSWER",
    "BUSY",
    "REJECTED",
  ];

  const errorStatuses = [
    "FAILED",
    "CONGESTION",
    "CANCEL",
    "CHANUNAVAIL",
    "NUMBER_UNALLOCATED",
    "TEMPFAILURE",
    "UNREACHABLE",
    "NUMBER_INVALID",
  ];

  // Both callStatus and callstatus_code can carry the status string depending
  // on record/call type (see backend note: callstatus_code defaults to "",
  // callStatus is used when callstatus_code is blank). Always resolve the
  // *effective* code first, then use that everywhere - for the color, the
  // label, and the audio/answered checks - so display never contradicts
  // whichever field the backend actually matched the filter on.
  const getEffectiveStatusCode = (item) => {
    if (item?.callstatus_code) return item.callstatus_code;
    return item?.callStatus || "";
  };

  const getCallStatusColor = (item) => {
    const code = getEffectiveStatusCode(item);
    if (successStatuses.includes(code)) return "green";
    if (warningStatuses.includes(code)) return "red";
    if (errorStatuses.includes(code)) return "red";
    return "gray";
  };

  const getDID = (item) => item?.DID || "-";
  const getDate = (item) => item?.legAstartTime  || "-";
  const getCustomerName = (item) =>
  item?.customer?.name === item?.customer?.number
    ? ""
    : item?.customer?.name || "";
  const getCustomerNumber = (item) => item?.customer?.number || "";
  const getCountryCode = (item) => item?.country_code || "-";
  const getAgentName = (item) => item?.agentName || item?.agent_name || item?.answeredAgent || "-";
  const getAgentNumber = (item) => item?.answeredAgent || item?.agent_number || "-";
  const getDestinationName = (item) => item?.destinationName || item?.destination_name || "-";
  const getCallDuration = (item) => item?.duration || "-";
  const getConnectedDuration = (item) => item?.connectedDuration ?? "-";
  const getRating = (item) => item?.feedback_rating || "-";
  const getCallDirection = (item) => item?.callDirection || "";
  const getComment = (item) => item?.comment || "-";
  const getStatus = (item) => callStatusData[getEffectiveStatusCode(item)] || "NOT APPLICABLE";
  const getVoiceFile = (item) => item?.callRecordVF || item?.voice_file || "";

  const downloadpdfData = (dataset, description) => {
    try {
      const doc = new jsPDF();
      doc.text("Virtual Sip Report", 10, 10);

      const tableData = dataset.flatMap((campaign_obj, index) => {
        return [
          [index < 9 ? `0${index + 1}` : `${index + 1}`, "DID", getDID(campaign_obj)],
          ["", "Date", getDate(campaign_obj)],
          ["", "Customer", `${getCustomerName(campaign_obj)} (${getCustomerNumber(campaign_obj)})`],
          ["", "Country Code", `+${getCountryCode(campaign_obj)}`],
          ["", "Agent", `${getAgentName(campaign_obj)} (${getAgentNumber(campaign_obj)})`],
          // ["", "Destination Name", getDestinationName(campaign_obj)],
          ["", "Call Duration", getCallDuration(campaign_obj)],
          ["", "Connected Duration", getConnectedDuration(campaign_obj)],
          ["", "Rating", getRating(campaign_obj)],
          ["", "Call Direction", getCallDirection(campaign_obj)],
          ["", "Comment", getComment(campaign_obj)],
          ["", "Status", getStatus(campaign_obj)],
          ["", "", ""], // spacing row
        ];
      });

      doc.autoTable({
        head: [["S.No", "Head", "Data"]],
        body: tableData,
        startY: 20,
        styles: {
          cellPadding: 1,
          fontSize: 10,
        },
        columnStyles: {
          0: { cellWidth: 20 },
          1: { cellWidth: 50 },
          2: { cellWidth: 110 },
        },
      });

      doc.save("VirtualSipReport.pdf");
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const getWavUrl = (voiceFile) => {
    if (!voiceFile) return "";
    let filename = voiceFile;
    if (filename.endsWith(".gsm")) {
      filename = filename.replace(".gsm", ".wav");
    } else if (filename.endsWith(".alaw")) {
      filename = filename.replace(".alaw", ".wav");
    }
    return `${BASE_URL}/uploads/downloadedWaveFile/${filename}`;
  };


  const downloadxcelData = (dataset, description) => {
    const excelData = [];

    dataset.forEach((item) => {
      const fullRow = {
        "DID": getDID(item),
        "Date": getDate(item),
        "Customer Name": getCustomerName(item),
        "Customer Number": getCustomerNumber(item),
        "Country Code": getCountryCode(item),
        "Agent Name": getAgentName(item),
        "Agent Number": getAgentNumber(item),
        // "Destination Name": getDestinationName(item),
        "Call Duration": getCallDuration(item),
        "Connected Duration": getConnectedDuration(item),
        "Rating": getRating(item),
        "Call Direction": getCallDirection(item),
        "Comment": getComment(item),
        "Status": getStatus(item),
        "Voice File": getStatus(item) === "Answered by destination"
          ? getWavUrl(getVoiceFile(item))
          : "",
      };

      // Keep only user-selected base columns + always include dynamic ones
      const filteredRow = {};
      Object.entries(fullRow).forEach(([k, v]) => {
        const isBaseColumn = EXCEL_COLUMNS.some((c) => c.key === k);
        if (!isBaseColumn || selectedColumns.has(k)) {
          filteredRow[k] = v;
        }
      });

      excelData.push(filteredRow);
    });

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(excelData);

    Object.keys(ws).forEach((cellAddress) => {
      if (cellAddress.startsWith("!")) return;
      const cell = ws[cellAddress];
      if (typeof cell.v === "string" && cell.v.startsWith("http")) {
        cell.l = { Target: cell.v };
        cell.t = "s";
      }
    });

    XLSX.utils.book_append_sheet(wb, ws, "VirtualSipReport");
    const blobData = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const excelBlob = new Blob([blobData], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = window.URL.createObjectURL(excelBlob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "VirtualSipReport.xlsx";
    a.click();
    window.URL.revokeObjectURL(url);
  };





  const [searchTerm, setSearchTerm] = useState('');
  const [selectedOption, setSelectedOption] = useState(null);
  const [showMenu, setShowMenu] = useState(false);

  // Filter options based on search term
  const filteredOptions = camplist.filter(option =>
    option.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleInputChange = (e) => {
    setSearchTerm(e.target.value);
    setShowMenu(true);
    if (e.target.value == '') {
      setCampaign("")
    }
  };

  const handleOptionSelect = (option) => {
    setSelectedOption(option);
    setSearchTerm(option.name); // Show selected label in input
    setShowMenu(false); // Hide menu after selection
    setCampaign(option.id)

  };

  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };
  
  const handleBlur = () => {
    // Delay hiding menu to allow option selection
    setTimeout(() => setShowMenu(false), 150);
  };
  

  return (
    <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6">
      <Popup
        open={fback}
        modal
        nested
        position="center center"
        contentStyle={{ width: "0px", marginTop: "-10px" }}
      >
        {(close) => (
          <CallFeedback
            setfback={setfback}
            close={close}
            customer={FBcampData.customer_data || null}
            call_id={FBcampData.call_id || null}
            camp_data={FBcampData.camp_data || null}
            FBdata={fbdata}
            setFBdata={setfbdata}
            viewfb={true}
            setCampaignReportData={setCampaignReportData}
            campaignRepotData={campaignRepotData}
          />
        )}
      </Popup>

      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-indigo-500 to-blue-500 flex items-center justify-center">
          <BarChart3 className="w-5 h-5 text-white" />
        </div>
        <h1 className="font-bold text-xl text-gray-900">VSIP Report</h1>
      </div>

      <div className="flex flex-col">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
          <div>
            <label htmlFor="table-search" className="block text-sm font-semibold text-gray-700 mb-1.5">
              Search for items
            </label>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                <svg
                  className="w-5 h-5 text-gray-500"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                    clipRule="evenodd"
                  ></path>
                </svg>
              </div>
              <input
                type="text"
                id="table-search"
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 w-full pl-10 p-2.5"
                placeholder="Search for items"
                onChange={(e) => setSearchText(e.target.value)}
                onFocus={() => setShowSearchTooltip(true)}
                onBlur={() => setShowSearchTooltip(false)}
                onMouseEnter={() => setShowSearchTooltip(true)}
                onMouseLeave={() => setShowSearchTooltip(false)}
              />

              {showSearchTooltip && (
                <div className="absolute z-20 top-full left-0 mt-1 bg-gray-800 text-white text-xs rounded-md px-3 py-1.5 whitespace-nowrap shadow-lg">
                  Enter DID, Agent Number
                  <div className="absolute -top-1 left-4 w-2 h-2 bg-gray-800 rotate-45"></div>
                </div>
              )}
            </div>
          </div>

          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-1.5">Select Call Status</label>
            <select
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 w-full p-2.5"
              value={status}
              onChange={(e) => setStatus(e.target.value)}
            >
              <option value="">All Statuses</option>
              {Object.entries(callStatusData).map(([code, label]) => (
                <option key={code} value={code}>
                  {label}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-1.5">Select Tag</label>
            <select
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 w-full p-2.5"
              value={chosenTag}
              onChange={(e) => setChosenTag(e.target.value)}
            >
              <option value="">Select Tags</option>
              {reportTags.map((tag, index) => (
                <option key={index} value={tag}>
                  {tag}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-1.5">Call Direction</label>
            <select
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 w-full p-2.5"
              value={callDirection}
              onChange={(e) => setCallDirection(e.target.value)}
            >
              <option value="">All Directions</option>
              <option value="outgoing">Outgoing</option>
              <option value="incoming">Incoming</option>
            </select>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-1.5">From</label>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                <svg
                  className="w-4 h-4 text-gray-500"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z" />
                </svg>
              </div>
              <input
                name="start"
                type="date"
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 w-full pl-10 p-2.5"
                onChange={(e) => setFromDate(e.target.value)}
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-1.5">To</label>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                <svg
                  className="w-4 h-4 text-gray-500"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z" />
                </svg>
              </div>
              <input
                name="end"
                type="date"
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 w-full pl-10 p-2.5"
                onChange={(e) => setToDate(e.target.value)}
              />
            </div>
          </div>
          <div>
            <label htmlFor="agent-filter" className="block text-sm font-semibold text-gray-700 mb-1.5">
              Agent
            </label>
            <div className="relative">
              <input
                id="agent-filter"
                type="text"
                role="combobox"
                aria-expanded={showAgentOptions}
                aria-controls="agent-filter-options"
                aria-autocomplete="list"
                autoComplete="off"
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 w-full p-2.5"
                placeholder="All Agents"
                value={agentSearch}
                onFocus={() => setShowAgentOptions(true)}
                onBlur={() => setTimeout(() => setShowAgentOptions(false), 150)}
                onChange={(e) => {
                  setAgentSearch(e.target.value);
                  setSelectedAgent("");
                  setShowAgentOptions(true);
                }}
              />
              {agentSearch && (
                <button
                  type="button"
                  onClick={() => {
                    setAgentSearch("");
                    setSelectedAgent("");
                    setShowAgentOptions(false);
                  }}
                  className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-500"
                  aria-label="Clear agent filter"
                >
                  ×
                </button>
              )}
              {showAgentOptions && (
                <div
                  id="agent-filter-options"
                  className="absolute left-0 top-full z-10 mt-1 max-h-48 w-full overflow-y-auto rounded-lg border border-gray-300 bg-white shadow-lg"
                  role="listbox"
                  onMouseDown={(e) => e.preventDefault()}
                >
                  <div
                    className="cursor-pointer px-3 py-2 text-sm hover:bg-gray-100"
                    onClick={() => {
                      setAgentSearch("");
                      setSelectedAgent("");
                      setShowAgentOptions(false);
                    }}
                    role="option"
                    aria-selected={!selectedAgent}
                  >
                    All Agents
                  </div>
                  {agents
                    .filter((agent) =>
                      (agent.profile_name || "")
                        .toLowerCase()
                        .includes(agentSearch.toLowerCase())
                    )
                    .map((agent) => (
                      <div
                        key={agent.user_profile}
                        className="cursor-pointer px-3 py-2 text-sm hover:bg-gray-100"
                        onClick={() => {
                          setSelectedAgent(String(agent.user_profile));
                          setAgentSearch(agent.profile_name || "");
                          setShowAgentOptions(false);
                        }}
                        role="option"
                        aria-selected={selectedAgent === String(agent.user_profile)}
                      >
                        {agent.profile_name}
                      </div>
                    ))}
                  {agents.filter((agent) =>
                    (agent.profile_name || "")
                      .toLowerCase()
                      .includes(agentSearch.toLowerCase())
                  ).length === 0 && (
                    <div className="px-3 py-2 text-sm text-gray-500">
                      No agents found
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
          <div className="flex items-end">
            <button
              className="w-full bg-blue-500 hover:bg-blue-700 text-white font-bold p-2.5 rounded-lg"
              onClick={SearchCampaign}
            >
              Submit
            </button>
          </div>
        </div>

        <div className="flex flex-wrap items-center gap-3 mb-4">
          <div
            className="flex items-center gap-2 bg-red-100 px-3 py-2 rounded-2xl cursor-pointer"
            onClick={() => downloadSheet("PDF")}
          >
            <Pdf className="w-5 h-5" />
            <span className="text-red-500 font-medium">PDF</span>
          </div>
          <div
            className="flex items-center gap-2 bg-green-100 px-3 py-2 rounded-2xl cursor-pointer"
            onClick={() => downloadSheet("EXCEL")}
          >
            <Excel className="w-5 h-5" />
            <span className="text-green-500 font-medium">Excel</span>
          </div>

          <div className="relative">
            <button
              className="flex items-center gap-2 bg-blue-50 border border-blue-300 text-blue-700 text-sm font-medium px-3 py-2 rounded-lg hover:bg-blue-100 transition"
              onClick={() => setShowColumnPicker((p) => !p)}
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M9 17V7m0 10a2 2 0 01-2 2H5a2 2 0 01-2-2V7a2 2 0 012-2h2a2 2 0 012 2m0 10a2 2 0 002 2h2a2 2 0 002-2M9 7a2 2 0 012-2h2a2 2 0 012 2m0 10V7" />
              </svg>
              Customize Excel Columns
              <span className="bg-blue-200 text-blue-800 text-xs rounded-full px-2 py-0.5">
                {selectedColumns.size}/{EXCEL_COLUMNS.length}
              </span>
            </button>

            {showColumnPicker && (
              <div className="absolute z-20 mt-1 bg-white border border-gray-200 rounded-xl shadow-xl p-4 w-72 left-0">
                <div className="flex justify-between items-center mb-3">
                  <h3 className="text-sm font-semibold text-gray-700">Select Columns</h3>
                  <button
                    className="text-xs text-blue-600 hover:underline"
                    onClick={toggleAllColumns}
                  >
                    {selectedColumns.size === EXCEL_COLUMNS.length ? "Deselect All" : "Select All"}
                  </button>
                </div>

                <div className="flex flex-col gap-2 max-h-64 overflow-y-auto">
                  {EXCEL_COLUMNS.map((col) => (
                    <label
                      key={col.key}
                      className="flex items-center gap-2 text-sm text-gray-700 cursor-pointer hover:bg-gray-50 px-1 py-0.5 rounded"
                    >
                      <input
                        type="checkbox"
                        className="accent-blue-500"
                        checked={selectedColumns.has(col.key)}
                        onChange={() => toggleColumn(col.key)}
                      />
                      {col.label}
                    </label>
                  ))}
                </div>

                <div className="mt-3 pt-2 border-t flex justify-end">
                  <button
                    className="text-sm bg-blue-500 hover:bg-blue-600 text-white px-4 py-1.5 rounded-lg"
                    onClick={() => setShowColumnPicker(false)}
                  >
                    Done
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="py-2 inline-block min-w-full ">
          <div className="overflow-x-auto">
            <table className="w-full ml-[-4rem]">
              <thead>
                <tr className="text-[#9AA7B5] text-[17px] font-karla font-[500]">
                  <td className="pl-[6.0rem] pr-[2.1rem]  py-4 text-left">
                    Sl-No
                  </td>
                  <td className="pl-[1.0rem] pr-[2.1rem]  py-4 text-left">
                    DID
                  </td>
                  <td className="pl-[1.0rem] pr-[2.1rem]  py-4 text-left">
                    Date
                  </td>
                  <td className="pl-[1.0rem] pr-[2.1rem]  py-4 text-left">
                    Customer
                  </td>
                  <td className="pl-[1.0rem] pr-[2.1rem]  py-4 text-left">
                    Country code
                  </td>
                  <td className="pl-[1.0rem] pr-[2.1rem]  py-4 text-left">
                    Agent
                  </td>
                  {/* <td className="pl-[1.0rem] pr-[2.1rem]  py-4 text-left">
                    Destination Name
                  </td> */}
                  <td className="pl-[1.0rem] pr-[2.1rem]  py-4 text-left">
                    Call Duration(sec)
                  </td>
                  <td className="pl-[1.0rem] pr-[2.1rem]  py-4 text-left">
                    Connected Duration(sec)
                  </td>
                  {/* <td className="pl-[1.0rem] pr-[2.1rem]  py-4 text-left">
                    Rating
                  </td> */}
                  <td className="pl-[1.0rem] pr-[2.1rem]  py-4 text-left">
                    Call Direction
                  </td>
                  {/* <td className="pl-[1.0rem] pr-[2.1rem]  py-4 text-left">
                    Comment
                  </td> */}
                  <td className="pl-[1.0rem] pr-[2.1rem]  py-4 text-left">
                    Status
                  </td>
                  <td className="pl-[1.0rem] pr-[2.1rem]  py-4 text-left">
                    Play/Pause
                  </td>
                  <td className="pl-[1.0rem] pr-[2.1rem]  py-4 text-left">
                    Download
                  </td>
                </tr>
              </thead>

              <tbody>
                {campaignRepotData.map((campaign_obj, index) => (
                  <tr
                    className="border-b text-[16px] font-karla text-gray-900  whitespace-nowrap"
                    key={0 + index}
                  >
                    <td className="pl-[6.0rem] pr-[2.1rem]  py-4">
                      {index +
                        1 +
                        (pagination?.current_page - 1) * pagination?.page_size}
                    </td>
                    <td className="pl-[1.0rem] pr-[2.1rem]  py-4 text-left">
                      {getDID(campaign_obj)}
                    </td>
                    <td className="pl-[1.0rem] pr-[2.1rem]  py-4 text-left">
                      {getDate(campaign_obj)}
                    </td>
                    <td className="pl-[1.0rem] pr-[2.1rem]  py-4 text-left">
                      {getCustomerName(campaign_obj)}
                      <br />
                      {getCustomerNumber(campaign_obj)}
                      <br />
                    </td>
                    <td className="pl-[1.0rem] pr-[2.1rem]  py-4 text-left">
                      +{getCountryCode(campaign_obj)}
                    </td>
                    <td className="pl-[1.0rem] pr-[2.1rem]  py-4 text-left">
                      {getAgentName(campaign_obj)}
                      <br />
                      {getAgentNumber(campaign_obj)}
                      <br />
                    </td>
                    {/* <td className="pl-[1.0rem] pr-[2.1rem]  py-4 text-left">
                      {getDestinationName(campaign_obj)}
                    </td> */}
                    <td className="pl-[1.0rem] pr-[2.1rem]  py-4  text-left	">
                      {getCallDuration(campaign_obj)}
                    </td>
                    <td className="pl-[1.0rem] pr-[2.1rem]  py-4 text-left">
                      {getConnectedDuration(campaign_obj)}
                    </td>
                    {/* <td className="pl-[1.0rem] pr-[2.1rem]  py-4 text-left">
                      {getRating(campaign_obj)}
                    </td> */}
                    <td className={`pl-[1.0rem] pr-[2.1rem]  py-4 text-left text-white`}>
                      {getCallDirection(campaign_obj).trim() !== ""?
                        <div className={`${getCallDirection(campaign_obj) === "outgoing" ? "bg-red-500 rounded-lg px-2" : "bg-green-500 rounded-lg px-2" }`}>
                          {getCallDirection(campaign_obj)}
                        </div>
                      :
                      ""
                      }
                    </td>
                    {/* <td className="pl-[1.0rem] pr-[2.1rem]  py-4 text-left">
                      {getComment(campaign_obj)}
                    </td> */}
                    <td className="pl-[1.0rem] pr-[2.1rem] py-4 text-left	">
                      <div className="flex justify-start gap-2">
                        <div className="mt-[4px]">
                          <Outgoing
                            width={12}
                            height={12}
                            fill={getCallStatusColor(campaign_obj)}
                          />
                        </div>
                        <p>{getStatus(campaign_obj)}</p>
                      </div>
                    </td>

                    <td className="pl-[1.1rem] cursor-pointer pr-[0.1rem] py-4 text-left">
                      {campaign_obj.callRecordVF &&
                        getEffectiveStatusCode(campaign_obj) === "ANSWERED" ? (
                        // <audio
                        //     key={campaign_obj.callRecordVF}
                        //     id={campaign_obj.callRecordVF}
                        //     preload="true"
                        //     controls
                        // >
                        //   <source
                        //     src={`${BASE_URL}/uploads/downloadedWaveFile/${campaign_obj.callRecordVF.replace(
                        //       ".gsm",
                        //       ".wav"
                        //     )}`}
                        //     type="audio/wav"
                        //   />
                        // </audio>
                        <audio
                          key={campaign_obj.callRecordVF}
                          id={campaign_obj.callRecordVF}
                          preload="true"
                          controls
                        >
                          <source
                            src={
                              resolvedWaveUrls[campaign_obj.callRecordVF] ||
                              getWavUrl(campaign_obj.callRecordVF)
                            }
                            type="audio/wav"
                          />
                        </audio>
                      ) : (
                        <p>No audio</p>
                      )}
                    </td>
                    <td className="pl-[2.1rem] cursor-pointer pr-[0.1rem] py-4 text-center	">
                      {campaign_obj.callRecordVF &&
                        getEffectiveStatusCode(campaign_obj) === "ANSWERED" ? (
                        <svg
                          width="25px"
                          height="25px"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          onClick={() => {
                            DownloadRecord(
                              campaign_obj.callRecordVF,
                              campaign_obj.legAstartTime,
                              index + 1
                            );
                          }}
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M12 3C12.5523 3 13 3.44772 13 4V12.5858L15.2929 10.2929C15.6834 9.90237 16.3166 9.90237 16.7071 10.2929C17.0976 10.6834 17.0976 11.3166 16.7071 11.7071L12.7071 15.7071C12.5196 15.8946 12.2652 16 12 16C11.7348 16 11.4804 15.8946 11.2929 15.7071L7.2929 11.7071C6.90238 11.3166 6.90238 10.6834 7.2929 10.2929C7.68342 9.90237 8.31659 9.90237 8.70711 10.2929L11 12.5858V4C11 3.44772 11.4477 3 12 3ZM4.00001 14C4.55229 14 5.00001 14.4477 5.00001 15C5.00001 15.9772 5.00485 16.3198 5.05765 16.5853C5.29437 17.7753 6.22466 18.7056 7.41474 18.9424C7.68018 18.9952 8.02276 19 9.00001 19H15C15.9772 19 16.3198 18.9952 16.5853 18.9424C17.7753 18.7056 18.7056 17.7753 18.9424 16.5853C18.9952 16.3198 19 15.9772 19 15C19 14.4477 19.4477 14 20 14C20.5523 14 21 14.4477 21 15C21 15.0392 21 15.0777 21 15.1157C21.0002 15.9334 21.0004 16.4906 20.9039 16.9755C20.5094 18.9589 18.9589 20.5094 16.9755 20.9039C16.4907 21.0004 15.9334 21.0002 15.1158 21C15.0778 21 15.0392 21 15 21H9.00001C8.96084 21 8.92225 21 8.88423 21C8.06664 21.0002 7.50935 21.0004 7.02456 20.9039C5.0411 20.5094 3.49061 18.9589 3.09608 16.9755C2.99965 16.4906 2.99978 15.9334 2.99999 15.1158C3 15.0777 3.00001 15.0392 3.00001 15C3.00001 14.4477 3.44772 14 4.00001 14Z"
                            fill="#0F1729"
                          />
                        </svg>
                      ) : (
                        <p>-</p>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
       {campaignRepotData.length > 0 ? (
          <>
            <div className="p-8">
              <Pagination
                pagination_data={pagination}
                PaginationControl={PaginationControl}
              />
            </div>
          </>
        ) : 
          null
        }
      </div>
    </div>
  );
}
export default VsipOutgoingCampaignReport;
